import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import EnergyHubReceiptList from './energy-hub-receipt-list';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Energy Hub Receipts">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/energy-hubs">Energy Hubs</Breadcrumb.Item>
            <Breadcrumb.Item active>Receipts</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <EnergyHubReceiptList />
    </Panel>
  );
};

export default Page;
